
const GraphQLMutation = require('app/graphql/Mutation');

class ShowView {
	defaultOptions() {
		return {
			'selector': '.view-order-delivery-show',
		};
	}

	constructor(options) {
		this.settings = $.extend(this.defaultOptions(), options);

        this.onSubmit = this.onSubmit.bind(this);

		this.$container = $(this.settings.selector);
		if(this.$container.length <= 0){
			window.notify("Can't find container view with selector " + this.settings.selector,'danger');
		}

		this.$form = $('.form-order-delivery',this.$container);

		this.initialize();
	}

	initialize() {
		var self = this;

        this.$form.on('submit',this.onSubmit);

	
	}

    getData(){
        return new FormData(this.$form[0]);
    }

    onSubmit(event){
        var self = this;
        event.preventDefault();
        event.stopPropagation();

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'order': {
                'value': this.settings.orderId,
                'type': 'Int!'
            },
        };

        let data = this.getData();

        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "SubmitOrderDelivery",
            'fields': fields,
            'variables': variables,
            'data': data,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                if(data.success){
                    window.notify(data.message,'success');
                }else{
                    window.notify(data.message,'error');
                }
            },
            'error': function(message, xhr){
                window.notify(message,'error');
            },
            'after': function(){
            }
        });
        mutation.execute();

    }


}

module.exports = ShowView;